import { render } from "./NumInput.vue?vue&type=template&id=270e21cc"
import script from "./NumInput.vue?vue&type=script&lang=js"
export * from "./NumInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/apriyadi/projects/investment-forecaster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__